import React from "react";
import { NavLink } from "react-router-dom";
import { Home, MessageCircle, GraduationCap } from "lucide-react";
import { useS } from "../lib/simple";
import { navGroups } from "../lib/navGroups";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-3 min-h-[44px] rounded-xl text-sm transition-colors ${
    isActive ? "bg-primary/15 text-white border border-primary/30" : "text-[hsl(var(--muted-foreground))] hover:text-white hover:bg-white/5 border border-transparent"
  }`;

export function SimpleNav({ onNavigate }) {
  const { s } = useS();
  return (
    <nav className="flex-1 px-3 space-y-1 overflow-y-auto" data-testid="simple-nav">
      <NavLink to="/app/dashboard" end data-testid="nav-dashboard" onClick={onNavigate} className={linkCls}><Home size={18} /> {s("n_home")}</NavLink>
      <NavLink to="/app/command" data-testid="nav-command" onClick={onNavigate} className={linkCls}><MessageCircle size={18} className="text-neon" /> {s("n_assistant")}</NavLink>
      {navGroups(s).map((g) => (
        <div key={g.id} className="pt-3" data-testid={`nav-group-${g.id}`}>
          <p className="px-3 pb-1 text-[10px] uppercase tracking-wide text-[#00E5FF]/80 font-semibold">{g.title}</p>
          {g.items.map((it) => (
            <NavLink key={it.id} to={it.to} data-testid={`nav-${it.id}`} onClick={onNavigate} className={linkCls}>
              <it.icon size={17} className="shrink-0" /> <span className="flex-1 truncate">{it.label}</span>
              {it.advanced && <span className="text-[9px] px-1.5 py-0.5 rounded bg-white/5 text-[hsl(var(--muted-foreground))]">{s("advanced")}</span>}
            </NavLink>
          ))}
        </div>
      ))}
      <div className="pt-3">
        <NavLink to="/app/help" data-testid="nav-help" onClick={onNavigate} className={linkCls}><GraduationCap size={18} /> {s("n_help")}</NavLink>
      </div>
    </nav>
  );
}
